import { render, staticRenderFns } from "./integral-detail.vue?vue&type=template&id=4d3c0d8c&scoped=true"
import script from "./integral-detail.vue?vue&type=script&lang=js"
export * from "./integral-detail.vue?vue&type=script&lang=js"
import style0 from "./integral-detail.vue?vue&type=style&index=0&id=4d3c0d8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3c0d8c",
  null
  
)

export default component.exports